import { getAllCustomers } from "../actionsGet/actionGetAllCustomers";
import { getCustomer } from "@State/index";
import getAPI from "@API/index";

export const editCustomer = (body, history) => {
  const trimmedBody = {
    id: body.id,
    name: body.name.trim(),
    externalId: body.externalId.trim(),
    type: body.type,
    email: body.email.trim(),
    status: body.status.trim(),
    subscriptionUntil: body.subscriptionUntil,
    ServerUrl: body.ServerUrl,
    oneSPackageName: body.oneSPackageName,
    leadNotificationEmails: body.leadNotificationEmails ?? [],
  };

  return (dispatch) => {
    getAPI()
      .request({
        method: "put",
        url: `/api/Customer`,
        data: trimmedBody,
        successText: "snackbar.success",
      })
      .then(() => {
        dispatch(getCustomer(body.id));
        dispatch(getAllCustomers());
      });
  };
};
